var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExtensionFill = function SvgExtensionFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 21H5q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19v-3.8q1.2 0 2.1-.762.9-.763.9-1.938t-.9-1.937A3.15 3.15 0 0 0 3 9.8V6q0-.824.587-1.412A1.93 1.93 0 0 1 5 4h4q0-1.05.725-1.775T11.5 1.5t1.775.725T14 4h4q.824 0 1.413.588Q20 5.175 20 6v4q1.05 0 1.775.725T22.5 12.5t-.725 1.775T20 15v4q0 .824-.587 1.413A1.93 1.93 0 0 1 18 21h-3.8q0-1.25-.787-2.125Q12.625 18 11.5 18t-1.912.875T8.8 21"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExtensionFill);
export { ForwardRef as ReactComponent };